import { Expose, Type } from 'class-transformer';
import { CourseEntity } from '@core/entities/course.entity';
import { NewsEntity } from '@core/entities/news.entity';
import { FaqEntity } from '@core/entities/faq.entity';
import { TaskEntity } from '@core/entities/task.entity';
import { GroupEntity } from '@core/entities/groups';
import { EventEntity } from '@core/entities/events.entity';
import { SurveyEntity } from '@core/entities/surveys.entity';
import { InstructorEntity } from '@core/entities/instructor.entity';
import { RoomEntity } from '@core/entities/room.entity';

export class GlobalSearchEntity {
  @Type(() => NewsEntity)
  news: Partial<NewsEntity>[] = [];

  @Expose({ name: 'event' })
  @Type(() => CourseEntity)
  events: Partial<EventEntity>[] = [];

  @Expose()
  @Type(() => GroupEntity)
  groups: Partial<GroupEntity>[] = [];

  @Expose({ name: 'task' })
  @Type(() => TaskEntity)
  tasks: Partial<TaskEntity>[] = [];

  @Expose({ name: 'faq' })
  @Type(() => FaqEntity)
  faqs: Partial<FaqEntity>[] = [];

  @Expose({ name: 'survey' })
  @Type(() => SurveyEntity)
  surveys: Partial<SurveyEntity>[] = [];

  @Type(() => CourseEntity)
  courses: Partial<CourseEntity>[] = [];

  @Expose({ name: 'instructor' })
  @Type(() => InstructorEntity)
  instructors: Partial<InstructorEntity>[] = [];

  @Expose({ name: 'room' })
  @Type(() => RoomEntity)
  rooms: Partial<RoomEntity>[] = [];
}
